export const t = {
  pl: {
    // Header
    nav: {
      services: 'Usługi',
      contact: 'Kontakt',
    },

    // Intro
    intro: {
      badge: 'Powered by AI',
      tagline: ['Aplikacje', 'AI', 'Wyniki'],
      heading1: 'Budujemy produkty',
      heading2: 'ze wsparciem AI',
      subtitle: 'Tworzymy nowoczesne aplikacje z użyciem narzędzi AI - szybciej, mądrzej, taniej.',
      cta: 'Umów się na spotkanie',
      services: 'Nasze usługi',
      features: ['Szybka realizacja', 'Integracja AI', 'Skalowalny kod', 'Wsparcie po wdrożeniu'],
    },

    // Services
    services: {
      label: 'Nasze usługi',
      title: 'Wszystko czego potrzebujesz w jednym miejscu',
      subtitle: 'Od aplikacji webowych i mobilnych, przez design, po backendy i bazy danych — dostarczamy kompleksowe rozwiązania IT.',
      items: [
        { icon: '🌐', title: 'Aplikacja webowa', desc: 'Tworzymy złożone aplikacje webowe wymagające serwisów po stronie backendu oraz baz danych. Nasze rozwiązania są łatwo skalowalne i oparte o chmurę, dopasowane do Twoich potrzeb.' },
        { icon: '📱', title: 'Aplikacja mobilna', desc: 'Tworzymy aplikacje mobilne od podstaw — intuicyjne i wygodne. Każda aplikacja powstaje w dwóch wersjach, w pełni kompatybilnych z systemami Android oraz iOS.' },
        { icon: '🖥️', title: 'Aplikacja desktopowa', desc: 'Tworzymy aplikacje desktopowe z dbałością o funkcjonalność i niezawodność. Stosujemy unikalne rozwiązania dobrane do Twoich oczekiwań, dla większej efektywności pracy.' },
        { icon: '🎨', title: 'Identyfikacja wizualna', desc: 'Pomagamy wyróżnić się wśród innych — tworzymy spójne elementy identyfikacji wizualnej. Nasi projektanci opracują minimalistyczny wizerunek robiący duży efekt.' },
        { icon: '✏️', title: 'UI/UX', desc: 'Projektujemy skuteczne rozwiązania w zakresie User Interface i User Experience. Dbamy o funkcjonalność i pozytywne wrażenia użytkowników na każdym etapie.' },
        { icon: '🗄️', title: 'Bazy danych i API', desc: 'Projektujemy i tworzymy bazy danych oraz serwisy przetwarzające dane. Tworzymy publiczne API, serwisy uwierzytelniające i rozwiązania IT szyte na miarę.' },
      ],
    },

    // Process
    process: {
      label: 'Jak pracujemy',
      title: 'Od pomysłu do produktu w kilka tygodni',
      subtitle: 'Ustrukturyzowany proces, który gwarantuje wysoką jakość i szybkie dostarczenie wartości.',
      steps: [
        { tag: 'Discovery', title: 'Zbieranie wymagań i analiza', desc: 'Rozmawiamy o Twoich celach, badamy potrzeby użytkowników i określamy zakres oraz priorytety projektu.' },
        { tag: 'Design', title: 'Projektowanie i architektura', desc: 'Projektujemy architekturę systemu, tworzymy makiety i planujemy przepływy danych.' },
        { tag: 'Development', title: 'Budowanie produktu', desc: 'Piszemy kod — szybciej i z mniejszą ilością błędów dzięki nowoczesnym narzędziom i dobrym praktykom.' },
        { tag: 'Testing', title: 'Testowanie i optymalizacja', desc: "Testujemy funkcjonalności, edge case'y i wydajność systemu pod realnym obciążeniem." },
        { tag: 'Deploy', title: 'Wdrożenie i monitoring', desc: 'Deployujemy na skalowalną infrastrukturę i monitorujemy działanie produktu w czasie rzeczywistym.' },
      ],
    },

    // Technologies
    technologies: {
      label: 'Stack technologiczny',
      title: 'Narzędzia, którym ufamy',
      subtitle: 'Używamy sprawdzonych technologii i najlepszych narzędzi AI, by dostarczać produkty najwyższej jakości.',
    },

    // Portfolio
    portfolio: {
      label: 'Portfolio',
      title: 'Nasze ostatnie realizacje',
      subtitle: 'Sprawdź jak przekładamy nasze założenia na rzeczywistość — zapoznaj się z realizacjami naszego zespołu.',
      projects: [
        { badge: 'Aplikacja mobilna', title: 'City Eat', desc: 'Aplikacja mobilna, dzięki której zamówisz jedzenie ze znajdujących się nieopodal food trucków.' },
        { badge: 'Aplikacja mobilna', title: 'Armada Golf Club', desc: 'Aplikacja mobilna dla członków klubu golfowego — turnieje, scorecard, szkolenia i aktualności w jednym miejscu.' },
        { badge: 'Aplikacja webowa', title: 'Inwestycje Deweloperskie', desc: 'Platforma, gdzie w jednym miejscu znajdziesz oferty nieruchomości z rynku pierwotnego od deweloperów z całej Polski.' },
      ],
    },

    // Armada Golf Club
    armada: {
      description: 'Aplikacja mobilna dla Armada Golf Club — jednego z najpiękniejszych klubów golfowych w Polsce. Aplikacja umożliwia członkom śledzenie turniejów, wyników, aktualności i szkoleń bezpośrednio z poziomu telefonu.',
      footer: 'Gracze mogą prowadzić scorecard podczas rundy, przeglądać osiągnięcia oraz zapisywać się na szkolenia — wszystko w jednym miejscu.',
    },

    // CityEat
    cityeat: {
      description: 'Aplikacja mobilna stworzona z myślą o biurowcach i imprezach masowych - dzięki niej będziesz mógł zamówić pyszny posiłek bez stania w kolejkach i odebrać jedzenie kiedy już będzie gotowe o czym poinformuje Cię aplikacja. Składając zamówienie za pośrednictwem CityEat masz możliwość zrobienia tego samodzielnie lub w grupie. W przypadku zamówień grupowych otrzymujesz 1% dodatkowego rabatu za każdą osobę, która dołączy do zamówienia.',
      footer: 'Teraz nie musisz się martwić, że dostarczone jedzenie będzie zimne. Dzięki CityEat jedzenie jest zawsze pod ręką!',
    },

    // Inwestycje Deweloperskie
    inwestycje: {
      title: 'Inwestycje Deweloperskie',
      badge: 'Aplikacja webowa',
      url: 'inwestycjedeweloperskie.com',
      description: 'Ogólnopolski portal ogłoszeniowy nieruchomości rynku pierwotnego. Sprawdź aktualną ofertę deweloperów w swoim mieście za darmo już dziś. Dzięki wyszukiwarce możesz szczegółowo określić takie parametry, jak lokalizacja, liczba pokoi, cena czy metraż.',
      description2: 'Skorzystaj z listy ofert żeby znaleźć swoje wymarzone lokum.',
      tech: 'Angular',
      techLabel: 'Technologie',
      scopeLabel: 'Zakres prac',
      scope: 'UI/UX Design, Frontend, Backend, Baza danych',
      typeLabel: 'Typ projektu',
      type: 'Aplikacja webowa',
      urlLabel: 'Strona projektu',
    },

    // Why Us
    whyUs: {
      label: 'Dlaczego Modernware',
      title: 'Współpraca, która po prostu działa',
      subtitle: 'Bez korporacyjnych barier, za to z AI, przejrzystymi zasadami i realnym wsparciem.',
      items: [
        {
          icon: '🤝',
          title: 'Bezpośredni kontakt z zespołem',
          desc: 'Od pierwszego spotkania do wdrożenia rozmawiasz z osobami, które faktycznie budują Twój produkt. Bez pośredników, bez przeciągania decyzji.',
        },
        {
          icon: '⚡',
          title: 'AI przyspiesza każdy projekt',
          desc: 'Używamy narzędzi AI, żeby dostarczać szybciej i z mniejszą liczbą błędów. Ty zyskujesz czas i pieniądze — my budujemy lepszy produkt.',
        },
        {
          icon: '📄',
          title: 'Umowa i NDA w standardzie',
          desc: 'Jasna umowa, określony zakres i NDA od pierwszego dnia. Żadnych ukrytych kosztów — wiesz dokładnie za co płacisz.',
        },
        {
          icon: '🛠️',
          title: 'Wsparcie po wdrożeniu',
          desc: 'Nie znikamy po oddaniu projektu. Rozwijamy, poprawiamy i utrzymujemy to, co razem zbudowaliśmy.',
        },
      ],
    },

    // Social Proof
    socialProof: {
      label: 'Wyniki mówią same za siebie',
      title: 'Zaufali nam i nie żałują',
      subtitle: 'Pracujemy z firmami, które chcą realnych wyników — nie tylko ładnych prezentacji.',
      stats: [
        { suffix: '+', label: 'zadowolonych klientów' },
        { suffix: '%', label: 'projektów oddanych na czas' },
        { label: 'średni wzrost konwersji klientów' },
        { label: 'czas reakcji na zgłoszenie' },
      ],
      reviews: [
        {
          text: 'Modernware dostarczyło nam aplikację webową z integracją AI, która zautomatyzowała 70% naszej obsługi klienta. Jakość kodu i szybkość realizacji przerosły nasze oczekiwania.',
          author: 'Michał Nowak',
          role: 'CEO, TechFlow sp. z o.o.',
          initials: 'MN',
          bg: '#1C3A2A',
        },
        {
          text: 'Współpraca przebiegała sprawnie od pierwszego spotkania. Zespół świetnie rozumiał nasze potrzeby i zaproponował rozwiązania AI, o których sami byśmy nie pomyśleli.',
          author: 'Anna Wiśniewska',
          role: 'Product Manager, Finaro',
          initials: 'AW',
          bg: '#1C2A3A',
        },
        {
          text: 'Dostaliśmy gotowy produkt z asystentem AI w 6 tygodni. Dzisiaj nasz asystent obsługuje ponad 200 zapytań dziennie bez żadnej interwencji człowieka. Polecam!',
          author: 'Piotr Kowalczyk',
          role: 'Founder, AutoMed',
          initials: 'PK',
          bg: '#2A1C2A',
        },
      ],
    },

    // Contact
    contact: {
      label: 'Kontakt',
      title: 'Zostaw kontakt — oddzwonimy do Ciebie',
      subtitle: 'Zostaw nam swoje dane, a my skontaktujemy się z Tobą w ciągu 24 godzin, by omówić szczegóły.',
      form: {
        name: 'Imię / Firma',
        namePlaceholder: 'Jan Kowalski',
        email: 'Email *',
        emailPlaceholder: 'jan@firma.pl',
        phone: 'Numer telefonu *',
        phonePlaceholder: '+48 000 000 000',
        message: 'Opisz projekt',
        messagePlaceholder: 'Czego potrzebujesz? Napisz kilka słów o swoim projekcie lub pomyśle...',
        submit: 'Oddzwoń do mnie',
      },
      footer: {
        copy: 'Wszelkie prawa zastrzeżone.',
      },
    },
  },

  en: {
    // Header
    nav: {
      services: 'Services',
      contact: 'Contact',
    },

    // Intro
    intro: {
      badge: 'Powered by AI',
      tagline: ['Apps', 'AI', 'Results'],
      heading1: 'We build products',
      heading2: 'with AI intelligence',
      subtitle: 'We build modern applications using AI tools - faster, smarter, cheaper.',
      cta: 'Book a meeting',
      services: 'Our services',
      features: ['Fast delivery', 'AI integration', 'Scalable code', 'Post-launch support'],
    },

    // Services
    services: {
      label: 'Our services',
      title: 'Everything you need in one place',
      subtitle: 'From web and mobile apps, through design, to backends and databases — we deliver comprehensive IT solutions.',
      items: [
        { icon: '🌐', title: 'Web Application', desc: 'We build complex web applications requiring backend services and databases. Our solutions are easily scalable and cloud-based, tailored to your needs.' },
        { icon: '📱', title: 'Mobile Application', desc: 'We build mobile apps from scratch — intuitive and convenient. Every app is delivered in two versions, fully compatible with Android and iOS.' },
        { icon: '🖥️', title: 'Desktop Application', desc: 'We create desktop applications with a focus on functionality and reliability. We use unique solutions tailored to your expectations for greater work efficiency.' },
        { icon: '🎨', title: 'Visual Identity', desc: 'We help you stand out — we create cohesive visual identity elements. Our designers will craft a minimalist image that makes a big impact.' },
        { icon: '✏️', title: 'UI/UX', desc: 'We design effective User Interface and User Experience solutions. We care about functionality and positive user impressions at every stage.' },
        { icon: '🗄️', title: 'Databases & API', desc: 'We design and build databases and data processing services. We create public APIs, authentication services and custom IT solutions.' },
      ],
    },

    // Process
    process: {
      label: 'How we work',
      title: 'From idea to product in a few weeks',
      subtitle: 'A structured process that guarantees high quality and fast delivery of value.',
      steps: [
        { tag: 'Discovery', title: 'Requirements gathering & analysis', desc: 'We talk about your goals, research user needs and define the scope and priorities of the project.' },
        { tag: 'Design', title: 'Design & architecture', desc: 'We design the system architecture, create mockups and plan data flows.' },
        { tag: 'Development', title: 'Building the product', desc: 'We write code — faster and with fewer bugs thanks to modern tools and best practices.' },
        { tag: 'Testing', title: 'Testing & optimisation', desc: 'We test features, edge cases and system performance under real load.' },
        { tag: 'Deploy', title: 'Deployment & monitoring', desc: 'We deploy on scalable infrastructure and monitor the product in real time.' },
      ],
    },

    // Technologies
    technologies: {
      label: 'Technology stack',
      title: 'Tools we trust',
      subtitle: 'We use proven technologies and the best AI tools to deliver the highest quality products.',
    },

    // Portfolio
    portfolio: {
      label: 'Portfolio',
      title: 'Our latest projects',
      subtitle: 'See how we turn our ideas into reality — explore our team\'s work.',
      projects: [
        { badge: 'Mobile app', title: 'City Eat', desc: 'A mobile app that lets you order food from nearby food trucks.' },
        { badge: 'Mobile app', title: 'Armada Golf Club', desc: 'A mobile app for golf club members — tournaments, scorecard, training and news all in one place.' },
        { badge: 'Web application', title: 'Inwestycje Deweloperskie', desc: 'A platform where you can find primary market real estate offers from developers across Poland.' },
      ],
    },

    // Armada Golf Club
    armada: {
      description: 'A mobile app for Armada Golf Club — one of the most beautiful golf clubs in Poland. The app lets members track tournaments, results, news and training sessions directly from their phone.',
      footer: 'Players can keep score during a round, view achievements and sign up for training — all in one place.',
    },

    // CityEat
    cityeat: {
      description: 'A mobile app designed for office buildings and mass events — it lets you order a delicious meal without standing in queues and pick it up when it\'s ready, with the app notifying you when it is. When placing an order through CityEat you can do it solo or as a group. For group orders you get an additional 1% discount for every person who joins the order.',
      footer: 'No more worrying about cold food. With CityEat, a great meal is always within reach!',
    },

    // Inwestycje Deweloperskie
    inwestycje: {
      title: 'Inwestycje Deweloperskie',
      badge: 'Web Application',
      url: 'inwestycjedeweloperskie.com',
      description: 'A nationwide property listing portal for the primary real estate market. Check the current offers from developers in your city for free today. Use the search engine to specify parameters such as location, number of rooms, price and square footage.',
      description2: 'Browse the listings to find your dream home.',
      tech: 'Angular',
      techLabel: 'Technologies',
      scopeLabel: 'Scope of work',
      scope: 'UI/UX Design, Frontend, Backend, Database',
      typeLabel: 'Project type',
      type: 'Web Application',
      urlLabel: 'Project website',
    },

    // Why Us
    whyUs: {
      label: 'Why Modernware',
      title: 'Collaboration that just works',
      subtitle: 'No corporate barriers — just AI, transparent terms and real support.',
      items: [
        {
          icon: '🤝',
          title: 'Direct team contact',
          desc: 'From the first meeting to launch, you talk directly with the people building your product. No middlemen, no slow decisions.',
        },
        {
          icon: '⚡',
          title: 'AI accelerates every project',
          desc: 'We use AI tools to deliver faster and with fewer bugs. You save time and money — we build a better product.',
        },
        {
          icon: '📄',
          title: 'Contract & NDA as standard',
          desc: 'A clear contract, defined scope and NDA from day one. No hidden costs — you know exactly what you\'re paying for.',
        },
        {
          icon: '🛠️',
          title: 'Post-launch support',
          desc: 'We don\'t disappear after delivery. We develop, fix and maintain what we\'ve built together.',
        },
      ],
    },

    // Social Proof
    socialProof: {
      label: 'Results speak for themselves',
      title: 'They trusted us and never looked back',
      subtitle: 'We work with companies that want real results — not just pretty presentations.',
      stats: [
        { suffix: '+', label: 'satisfied clients' },
        { suffix: '%', label: 'projects delivered on time' },
        { label: 'average client conversion growth' },
        { label: 'response time to enquiries' },
      ],
      reviews: [
        {
          text: 'Modernware delivered a web app with AI integration that automated 70% of our customer support. The code quality and speed of delivery exceeded our expectations.',
          author: 'Michał Nowak',
          role: 'CEO, TechFlow sp. z o.o.',
          initials: 'MN',
          bg: '#1C3A2A',
        },
        {
          text: 'The collaboration went smoothly from the very first meeting. The team understood our needs perfectly and proposed AI solutions we wouldn\'t have thought of ourselves.',
          author: 'Anna Wiśniewska',
          role: 'Product Manager, Finaro',
          initials: 'AW',
          bg: '#1C2A3A',
        },
        {
          text: 'We got a finished product with an AI assistant in 6 weeks. Today our assistant handles over 200 queries a day without any human intervention. Highly recommended!',
          author: 'Piotr Kowalczyk',
          role: 'Founder, AutoMed',
          initials: 'PK',
          bg: '#2A1C2A',
        },
      ],
    },

    // Contact
    contact: {
      label: 'Contact',
      title: 'Leave your contact — we\'ll call you back',
      subtitle: 'Leave us your details and we\'ll get in touch within 24 hours to discuss the details.',
      form: {
        name: 'Name / Company',
        namePlaceholder: 'John Smith',
        email: 'Email *',
        emailPlaceholder: 'john@company.com',
        phone: 'Phone number *',
        phonePlaceholder: '+1 000 000 0000',
        message: 'Describe your project',
        messagePlaceholder: 'What do you need? Write a few words about your project or idea...',
        submit: 'Call me back',
      },
      footer: {
        copy: 'All rights reserved.',
      },
    },
  },
};
